const id_purch_po = {
    "": "purchase order",
    create: "buat purchase order",
    edit: "ubah purchase order",
    currency: "mata uang",
    additional_cost: "biaya tambahan",
    additional_discount: "potongan tambahan",
    price_history: "riwayat harga",
    po_detail: "detail purchase order",

    create_mitra: "buat purchase order mitra",
    edit_mitra: "ubah purchase order mitra",

    dp_record: "pencatatan down payment",

    label: {
        exchange_rate: "kurs rupiah",
        btn_dp: "catat down payment",
    },

    message: {
        dp_note: "Terdapat pembayaran down payment pada {{date}} sebesar {{nominal}}",

        conf_dp_title: "Membatalkan DP",
        conf_dp_text: "Apakah Anda yakin untuk membatalkan DP?",

        delete_po_title: "Apakah Anda yakin untuk membatalkan PO?",
        delete_po_text: "Masukkan alasan pembatalan PO.",

        reject_po_title: "Apakah Anda yakin untuk membatalkan PO?",
        reject_po_text: "Masukkan alasan pembatalan PO.",

        reject_do_title: "Apakah Anda yakin untuk membatalkan DO?",
        reject_do_text: "Masukkan alasan pembatalan DO.",
    },

    error: {
        cancel_dp: "Gagal membatalkan down payment (DP).",
        create: "Gagal membuat PO.",
        create_do: "Gagal membuat referensi barang masuk (DO IN).",
        create_dp: "Gagal melakukan pembayaran down payment.",
        delete: "Gagal membatalkan PO.",
        edit: "Gagal mengubah PO.",

        reject: "Gagal membatalkan PO.",
        approve: "Gagal mengonfirmasi PO.",
        done: "Gagal menyelesaikan PO.",
    },

    success: {
        cancel_dp: "Berhasil membatalkan down payment (DP).",
        create: "Berhasil membuat PO.",
        create_do: "Berhasil membuat referensi barang masuk (DO IN).",
        create_dp: "Berhasil melakukan pembayaran down payment.",
        delete: "Berhasil membatalkan PO.",
        edit: "Berhasil mengubah PO.",

        reject: "Berhasil membatalkan PO.",
        approve: "Berhasil mengonfirmasi PO.",
        done: "Berhasil menyelesaikan PO.",
    },
}

export default id_purch_po;